export const shouldShowSeoContent = (authReady, user) => authReady && !user;
